import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListFormulaCardTypeMappingsResponse } from '../types';

const listFormulaCardTypeMappingsQuery = gql`
  query OvertimeListFormulaCardTypeMappings {
    overtimeListFormulaCardTypeMappings {
      code
      success
      message
      data {
        typeMappings {
          id
          overtimeType
          formulaCardId
          createdAt
        }
        total
      }
    }
  }
`;

const listFormulaCardTypeMappings = () => {
  return graphQLApi<ListFormulaCardTypeMappingsResponse, Record<string, never>>({
    query: listFormulaCardTypeMappingsQuery,
    queryVariables: {},
  });
};

export default listFormulaCardTypeMappings;
